import { memo, useContext, useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CallTopicContext } from '../../../contexts/CallTopicContext';
import Timeline from './Timeline';
import { getLocationAndWidth } from '../../../utils/mediaTimelineUtils';
import CurrentCallTopicUpdater from './CurrentCallTopicUpdater';
import PrevCallTopicButton from './PrevCallTopicButton';
import NextCallTopicButton from './NextCallTopicButton';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { Box } from 'foundations-components/transitional/components/Box';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallTopicsTimeline = () => {
  const {
    preciseDuration
  } = useContext(MediaPlaybackControlsContext);
  const {
    callTopics,
    selectedCallTopic,
    hoveredCallTopic,
    handleHoveredCallTopicToggle,
    handleSelectedCallTopicToggle
  } = useContext(CallTopicContext);
  const pills = useMemo(() => {
    return callTopics.map(pill => {
      const locationAndWidth = getLocationAndWidth(pill.startTimeSeconds, pill.endTimeSeconds, preciseDuration, true);
      const startLocation = locationAndWidth.startLoc;
      const width = locationAndWidth.width;
      return {
        id: pill.callTopicId,
        startLocation,
        width,
        borderColor: 'border-core-default',
        fillColor: selectedCallTopic === pill.callTopicId || hoveredCallTopic === pill.callTopicId ? 'fill-accent-neutral-hover' : 'fill-tertiary-default',
        onPillHover: () => {
          handleHoveredCallTopicToggle(pill.callTopicId);
        },
        onPillUnhover: () => {
          handleHoveredCallTopicToggle(pill.callTopicId);
        },
        onPillClick: () => {
          handleSelectedCallTopicToggle(pill.callTopicId, pill);
        }
      };
    });
  }, [callTopics, preciseDuration, handleHoveredCallTopicToggle, handleSelectedCallTopicToggle, hoveredCallTopic, selectedCallTopic]);
  if (callTopics.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Box, {
    "data-test-id": "mediaTimeline-callTopicTimeline",
    marginBlockStart: "500",
    marginBlockEnd: "200",
    children: [/*#__PURE__*/_jsx(CurrentCallTopicUpdater, {}), /*#__PURE__*/_jsx(Timeline, {
      timelineName: "call-topic",
      leftColContent: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "recordingReviewComponents.callTopics.topicsLabel"
      }),
      rightColContent: /*#__PURE__*/_jsxs(Flex, {
        position: "relative",
        zIndex: 1,
        children: [/*#__PURE__*/_jsx(PrevCallTopicButton, {}), /*#__PURE__*/_jsx(NextCallTopicButton, {})]
      }),
      pills: pills
    })]
  });
};
export default /*#__PURE__*/memo(CallTopicsTimeline);